// REISOR_FREIGHT_CONTACT_CONTEXT_V1
// Pure UI helper: builds a short messenger draft from the freight card already open.
// It never changes contact authorization, order data, or backend state.

function cleanDraftPart(value) {
  const text = String(value || "")
    .replace(/\s+/g, " ")
    .trim();

  return text === "—" ? "" : text;
}

export function buildFreightContactDraft({
  from = "",
  to = "",
  truck = "",
  language = "ru",
} = {}) {
  const fromText = cleanDraftPart(from);
  const toText = cleanDraftPart(to);
  const route = [fromText, toText].filter(Boolean).join(" → ");

  if (!route) return "";

  const truckText = cleanDraftPart(truck);
  const truckPart = truckText ? `, ${truckText}` : "";
  const lang = String(language || "ru")
    .trim()
    .toLowerCase()
    .slice(0, 2);

  if (lang === "uz") {
    return `Ассалому алайкум! ${route}${truckPart} йўналишидаги юк бўйича ёзяпман. Юк ҳали актуалми?`;
  }

  if (lang === "tr") {
    return `Merhaba! ${route}${truckPart} yükü hakkında yazıyorum. Yük hâlâ güncel mi?`;
  }

  return `Здравствуйте! По поводу груза ${route}${truckPart}. Груз актуален?`;
}
